import { LitElement, html, TemplateResult } from 'lit';
import { property } from 'lit/decorators.js';
import { Cell, isCellConfig, isRowConfig, Row } from '../types/types';
import { styles } from '../view/styles';

export class GzBasicTableWebComponent extends LitElement {
  @property({ type: Array, attribute: true })
  data: Array<Row> = [];

  @property({ type: Boolean, attribute: true, reflect: true })
  alignLastColumnRight = false;

  /**
   * If true, the rows should highlight all cells when hovered. The click
   * event should be handled for the entire rows as one item.
   */
  @property({ type: Function, attribute: true })
  rowsClickable = false;

  /**
   * If true, the cells should be highlighted individually when hovered.
   * The click event should be handled for each cell as one item.
   */
  @property({ type: Function, attribute: true })
  cellsClickable = false;

  @property({ type: Function, attribute: true })
  onClick: (rowData: unknown, cellData: unknown) => void | Promise<void> = () => undefined;

  constructor() {
    super();

    if (this.rowsClickable && this.cellsClickable) {
      throw new Error('Cannot have clickable behaviour for both rows and cells, read the docs please.');
    }
  }

  static get styles() {
    return styles;
  }

  render() {
    return html` <div class="table" part="table">${this.data.map((data, i) => this.renderTableRow(i, data))}</div> `;
  }

  private renderTableRow(index: number, row: Row): TemplateResult {
    const cells = isRowConfig(row) ? row.cells : row;
    const rowData = isRowConfig(row) ? row.data : undefined;

    return html` <div class="row" part="row row-${index}">
      ${cells.map((cell, i) => this.renderTableCell(i, rowData, cell))}
    </div> `;
  }

  private renderTableCell(index: number, rowData: unknown, cell: Cell): TemplateResult {
    const cellContent = isCellConfig(cell) ? cell.html : cell;
    const cellData = isCellConfig(cell) ? cell.data : undefined;
    const isClickable = isCellConfig(cell) ? !cell.disableClick : true;

    return html` <div class="cell" part="cell column-${index}" @click=${isClickable ? () => this.onClick(rowData, cellData) : null}>
      <div class="d-contents" part="cell-content column-content-${index}">
        ${cellContent}
      </div>
    </div>`;
  }
}
